// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".addSlash+.addSlash[data-v-261825e7]:before{border-right:.1em solid;content:\"\";display:inline-block;height:.8em;margin:0 .25rem 0 .25em;padding-left:.25rem;transform:rotate(15deg)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
